export const GetDivision = async () => {
    const respone = await fetch("api/Division/GetAll")
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {});
    return respone;
  };